<template>
  <div class="productpage__posting">
    <!-- eslint-disable-next-line -->
    <p v-if="$route.path.match('picture-lineart')" v-html="$t('product.posting_desc_line_art')"></p>
    <p v-else v-html="$t('product.posting_desc', { days: postingDays })"></p>
  </div>
</template>

<script>
export default {
  name: 'ProductPostingDays',
  props: {
    postingDays: {
      type: Number,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.productpage__posting {
  b {
    border-bottom: 2px solid $v4_color_text;
    display: inline-block;
  }
}
</style>
